import { Typography, type TypographyProps, useTheme } from '@mui/material';
import { getTypographySx } from './styles.ts';

export type Variants = 'orange' | 'green'
export const JuicyTypography = (props: TypographyProps & { variantStyle?: Variants }) => {
  const theme = useTheme();
  const { sx, variant, variantStyle = 'green', ...rest } = props;
  return (
    <Typography
      variant={variant || 'accent'}
      sx={getTypographySx(theme, variantStyle, sx)} {...rest} />
  );
};
